"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TabContainer = _styledComponents["default"].ul.withConfig({
  displayName: "TabSwitcher__TabContainer",
  componentId: "byg2ds-0"
})(["&&&{background-color:", ";list-style:none;display:flex;margin:21px 0 0 0;padding:0;border:1px solid ", ";flex-wrap:wrap;}"], function (props) {
  return props.styles.backgroundColor;
}, function (props) {
  return props.styles.borderColor;
});

var Tab = _styledComponents["default"].li.withConfig({
  displayName: "TabSwitcher__Tab",
  componentId: "byg2ds-1"
})(["&&&{min-width:107px;height:31px;padding:7px 19px;font-size:0.9rem;font-weight:bold;text-align:center;color:", ";background-color:", ";border-left:", ";border-right:", ";:first-child{border-left:none;}&:hover{cursor:pointer;}}"], function (props) {
  return props.active ? props.styles.activeColor : props.styles.defaultColor;
}, function (props) {
  return props.active ? props.styles.backgroundColor : undefined;
}, function (props) {
  return props.active ? "1px solid ".concat(props.styles.borderColor) : undefined;
}, function (props) {
  return props.active ? "1px solid ".concat(props.styles.borderColor) : undefined;
});

var Indicator = _styledComponents["default"].span.withConfig({
  displayName: "TabSwitcher__Indicator",
  componentId: "byg2ds-2"
})(["&&&{font-size:12px;display:", ";color:", ";}"], function (props) {
  return props.dirty ? "inline-block" : "none";
}, function (props) {
  return props.theme["almost-black"];
});

var ComponentContainer = _styledComponents["default"].div.attrs(function (props) {
  return {
    className: props.hasPadding ? "p-4" : ""
  };
}).withConfig({
  displayName: "TabSwitcher__ComponentContainer",
  componentId: "byg2ds-3"
})(["&&&{background-color:", ";border-left:1px solid ", ";border-right:1px solid ", ";border-bottom:1px solid ", ";}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.styles.borderColor;
}, function (props) {
  return props.styles.borderColor;
}, function (props) {
  return props.styles.borderColor;
});

var TabSwitcher = function TabSwitcher(_ref) {
  var tabs = _ref.tabs,
      styles = _ref.styles,
      onSwitch = _ref.onSwitch,
      hasPadding = _ref.hasPadding,
      canChange = _ref.canChange,
      activeTabIndex = _ref.activeTabIndex;
  var Theme = (0, _react.useContext)(_styledComponents.ThemeContext);
  var DefaultStyle = {
    tab: {
      backgroundColor: Theme["white"],
      borderColor: Theme["grey-two"],
      activeColor: Theme["primary"],
      defaultColor: Theme["almost-black"]
    },
    container: {
      backgroundColor: Theme["almost-white"],
      borderColor: Theme["grey-two"]
    }
  };

  var containsNewTabs = function containsNewTabs(list1, list2) {
    if (list1.length !== list2.length) {
      return true;
    }

    for (var i = 0; i < list1.length; i++) {
      if (list1[i].name !== list2[i].name) {
        return true;
      }
    }

    return false;
  };

  (0, _react.useEffect)(function () {
    tabs = updateTabs(tabs);
  }, []);
  (0, _react.useEffect)(function () {
    if (containsNewTabs(tabs, tabsState)) {
      tabs = updateTabs(tabs);
      setTabsState(tabs);
    }
  }, [tabs]);
  (0, _react.useEffect)(function () {
    if (activeTabIndex !== null) {
      setActiveTab(activeTabIndex);
    }
  }, [activeTabIndex]);

  var updateTabs = function updateTabs(tabs) {
    tabs = tabs ? tabs.slice().map(function (t) {
      return _objectSpread({}, t, {
        active: false,
        dirty: false
      });
    }) : [];

    if (tabs.length > 0) {
      if (activeTabIndex) {
        tabs[activeTabIndex].active = true;
      } else {
        tabs[0].active = true;
      }
    }

    return tabs;
  };

  var setActiveTab = function setActiveTab(index) {
    var copyTabs = tabsState.slice();
    copyTabs.forEach(function (c) {
      return c.active = false;
    });
    copyTabs[index].active = true;
    setTabsState(copyTabs);
    onSwitch(index);
  };

  var renderContent = function renderContent(active) {
    if (active) {
      if (_typeof(active.component) === _typeof({})) {
        return active.component;
      } else {
        var RenderComponent = active.component;
        return _react["default"].createElement(RenderComponent, null);
      }
    }

    return _react["default"].createElement("div", null, "No Component Found");
  };

  var CompStyles = {
    tab: _objectSpread({}, DefaultStyle.tab, {}, styles.tab),
    container: _objectSpread({}, DefaultStyle.container, {}, styles.container)
  }; //Setup our initial list of tabs

  tabs = updateTabs(tabs); //Initialize tabsState to our now updated list of tabs

  var _useState = (0, _react.useState)(tabs),
      _useState2 = _slicedToArray(_useState, 2),
      tabsState = _useState2[0],
      setTabsState = _useState2[1]; //Find the tab that should be active by default


  var active = tabsState.find(function (t) {
    return t.active;
  });
  return _react["default"].createElement("div", null, _react["default"].createElement(TabContainer, {
    styles: CompStyles.container
  }, tabsState.map(function (t, index) {
    return _react["default"].createElement(Tab, {
      active: t.active,
      onClick: function onClick() {
        onSwitch(index);

        if (canChange()) {
          setActiveTab(index);
        }
      },
      key: index,
      styles: CompStyles.tab
    }, t.name, " ", _react["default"].createElement(Indicator, {
      dirty: t.dirty,
      styles: CompStyles.tab
    }, "*"));
  })), _react["default"].createElement(ComponentContainer, {
    hasPadding: hasPadding,
    styles: CompStyles.container
  }, renderContent(active)));
};

TabSwitcher.propTypes = {
  /** tabs to display in the tab switcher */
  tabs: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    tab: _propTypes["default"].string,
    component: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].element, _propTypes["default"].func]),
    active: _propTypes["default"].bool
  })).isRequired,

  /** overrideable styling for the tab switcher */
  styles: _propTypes["default"].shape({
    tab: _propTypes["default"].shape({
      backgroundColor: _propTypes["default"].string,
      borderColor: _propTypes["default"].string,
      activeColor: _propTypes["default"].string,
      defaultColor: _propTypes["default"].string
    }),
    container: _propTypes["default"].shape({
      backgroundColor: _propTypes["default"].string,
      borderColor: _propTypes["default"].string
    })
  }),

  /** callback when tab is switched */
  onSwitch: _propTypes["default"].func,

  /** does the tab switcher give default padding to its children */
  hasPadding: _propTypes["default"].bool,

  /** callback to determine if the tab can switch */
  canChange: _propTypes["default"].func,

  /** the index of the currently active tab to display */
  activeTabIndex: _propTypes["default"].number
};
TabSwitcher.defaultProps = {
  styles: {
    tab: {},
    container: {}
  },
  onSwitch: function onSwitch() {},
  canChange: function canChange() {
    return true;
  },
  hasPadding: true,
  activeTabIndex: null
};
var _default = TabSwitcher;
exports["default"] = _default;